const doc = [({"da":({"js":({"admin":({"reimbursements":({"attachments":({"my_attachments":"Mine bilag", "all_attachments":"Alle bilag"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;